import { Link } from '@src/i18n/routing';

import CardBadge from './card-badge';
import { CardImage } from './card-image';
import { CardActions, CardContent, CardWrapper } from './styles';
import { CardProps } from './types';

export const Card = ({ children, href, ...props }: CardProps) => (
  <Link href={href}>
    <CardWrapper {...props}>{children}</CardWrapper>
  </Link>
);

Card.Image = CardImage;
Card.Content = CardContent;
Card.Actions = CardActions;
Card.Badge = CardBadge;
